import { useTranslation } from 'react-i18next';

import { ListItem } from '@app/shared/ui/molecules/DailyEnergyDescription';
import { newMoonIcon, waxingMoonIcon, fullMoonIcon, waningMoonIcon } from '@app/assets';

interface Item {
  id: string;
  imageSrc: string;
  imageAlt: string;
  translationKey: string;
}

const ITEMS: Item[] = [
  { id: '1', imageSrc: newMoonIcon, imageAlt: 'new moon', translationKey: 'new_moon' },
  { id: '2', imageSrc: waxingMoonIcon, imageAlt: 'waxing moon', translationKey: 'waxing_moon' },
  { id: '3', imageSrc: fullMoonIcon, imageAlt: 'full moon', translationKey: 'full_moon' },
  { id: '4', imageSrc: waningMoonIcon, imageAlt: 'waning moon', translationKey: 'waning_moon' },
];

export function MoonPhasesList() {
  const { t } = useTranslation();

  return (
    <ul className="flex flex-col gap-2">
      {ITEMS.map((item) => (
        <ListItem
          key={item.id}
          imageSrc={item.imageSrc}
          imageAlt={item.imageAlt}
          title={t(`daily_energy_description.${item.translationKey}.title`)}
          description={t(`daily_energy_description.${item.translationKey}.description`)}
        />
      ))}
    </ul>
  );
}
